// extracted by mini-css-extract-plugin
export default {"title":"Info_title__iwtTn","copy":"Info_copy__Dd2gE"};